export const handleSpeackerClick = ($speakerInner, audioElement, setupMediaElement) => {

	let mediaElementSetup = false;
	let soundOn = false; // @TODO : persist it in localStorage or cookie

	$speakerInner.click(() => {

		console.log('clicked on speaker');

		if (!mediaElementSetup) {
			setupMediaElement(audioElement);
			mediaElementSetup = true;
		}

		if (soundOn) {
			soundOn = false;
			audioElement.pause(); // turn off sound
		}
		else {
			soundOn = true;
			audioElement.play(); // turn on sound
		}
	});
};